
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  addSelectorToStoreAndSaveSelectorsToWordPressIfSelectorsPanelIsClosed,
  createCssSelectorObjectFromSelectorName
} from "@/lib/selectors/selectors";
import NotificationLogger from "@/lib/notifications/notifications";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { NiceButton, TextInput }
})
export default class AddSelector extends Vue {
  newSelectorName: string | null = "";

  addSelector() {
    if (!this.newSelectorName) return;

    pipe(
      createCssSelectorObjectFromSelectorName(this.newSelectorName),
      fold(
        errors => errors.forEach(NotificationLogger.log.message),
        selector =>
          addSelectorToStoreAndSaveSelectorsToWordPressIfSelectorsPanelIsClosed(
            selector
          )
      )
    );

    this.newSelectorName = "";
  }
}
